import { Link, Navigate, useNavigate, useSearchParams } from 'react-router-dom'
import { OtpCodeForm } from '@/components/auth/OtpCodeForm'
import { supabase } from '@/integrations/supabase/client'

export const EmailVerificationPage = () => {
    const [searchParams] = useSearchParams()
    const email = searchParams.get('email') ?? ''
    const navigate = useNavigate()

    if (!email) {
        return <Navigate to="/login" replace />
    }

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
            <div className="max-w-md w-full space-y-8">
                <div className="text-center">
                    <h2 className="mt-6 text-3xl font-extrabold text-gray-900">
                        Vérifiez votre e-mail
                    </h2>
                    <p className="mt-2 text-sm text-gray-600">
                        Nous avons envoyé un code de vérification à <strong>{email}</strong>.
                    </p>
                </div>

                <OtpCodeForm
                    submitLabel="Activer mon compte"
                    onVerify={async (code) => {
                        const result = await supabase.auth.verifyOtp({ email, token: code, type: 'email' })
                        if (!result.error) navigate('/dashboard', { replace: true })
                        return result
                    }}
                    onResend={() => supabase.auth.resend({ type: 'signup', email })}
                >
                    <Link to="/login" className="text-indigo-600 hover:text-indigo-500">
                        Retour à la connexion
                    </Link>
                </OtpCodeForm>

                <div className="bg-blue-50 border border-blue-200 rounded-md p-4 text-sm text-blue-700">
                    <p className="font-medium text-blue-800">Aucun code reçu ?</p>
                    <p className="mt-1">
                        Si cette adresse a déjà un compte, aucun code n'est envoyé.{' '}
                        <Link to="/login" className="font-medium text-blue-600 hover:text-blue-800">
                            Connectez-vous
                        </Link>{' '}
                        ou{' '}
                        <Link to="/reset-password-request" className="font-medium text-blue-600 hover:text-blue-800">
                            réinitialisez votre mot de passe
                        </Link>
                        .
                    </p>
                </div>
            </div>
        </div>
    )
}
